module.exports = __webpack_public_path__ + "media/pricing/IndividualPlan_PricingPage-601d2f1c.png";